import React from "react";
import Icon from "../../../../components/Icon";

export function AssetProfileDrawer({
  asset,
  onClose,
  subnets = [],
  connectionTestResult = {},
  onDeployAgent,
}) {
  if (!asset) return null;

  const subnetObj = subnets.find((s) => s.id === asset.subnet_id);

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(15, 23, 42, 0.15)",
          backdropFilter: "blur(1px)",
          zIndex: 1050,
        }}
      />
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          width: 460,
          background: "#fff",
          borderLeft: "1px solid #E5E7EB",
          boxShadow: "-10px 0 30px rgba(0,0,0,0.08)",
          zIndex: 1100,
          display: "flex",
          flexDirection: "column",
          padding: 24,
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
            borderBottom: "1px solid #F3F4F6",
            paddingBottom: 12,
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: 16,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            Asset Profile
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 4,
            }}
          >
            <Icon name="x" size={18} color="#6B7280" />
          </button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              Asset Name
            </span>
            <div
              style={{
                fontSize: 15,
                fontWeight: 700,
                color: "#111827",
                marginTop: 2,
              }}
            >
              {asset.name || "unnamed-candidate"}
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
            }}
          >
            <div>
              <span
                style={{
                  fontSize: 11,
                  color: "#6B7280",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                IP Address
              </span>
              <div
                style={{
                  fontSize: 13,
                  color: "#374151",
                  fontFamily: "monospace",
                  marginTop: 2,
                }}
              >
                {asset.ip}
              </div>
            </div>
            <div>
              <span
                style={{
                  fontSize: 11,
                  color: "#6B7280",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                Type classification
              </span>
              <div
                style={{
                  fontSize: 13,
                  color: "#374151",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  marginTop: 2,
                }}
              >
                {asset.type}
              </div>
            </div>
          </div>

          <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 12 }}>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              Subnet
            </span>
            <div style={{ fontSize: 13, color: "#374151", marginTop: 2 }}>
              {subnetObj
                ? `${subnetObj.name} (${subnetObj.subnet})`
                : asset.subnet_id}
            </div>
          </div>

          <div>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              Open Ports List
            </span>
            <div
              style={{
                display: "flex",
                gap: 6,
                flexWrap: "wrap",
                marginTop: 4,
              }}
            >
              {asset.openPorts?.map((p) => (
                <span
                  key={p}
                  style={{
                    fontSize: 11,
                    fontFamily: "monospace",
                    background: "#EFF6FF",
                    color: "#1D4ED8",
                    padding: "2px 6px",
                    borderRadius: 4,
                    border: "1px solid #BFDBFE",
                  }}
                >
                  {p}
                </span>
              ))}
            </div>
          </div>

          <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 12 }}>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              SSH Reachability
            </span>
            <div style={{ fontSize: 13, color: "#374151", marginTop: 2 }}>
              {asset.sshReachable || "Never checked"}
            </div>
          </div>

          <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 12 }}>
            <span
              style={{
                fontSize: 11,
                color: "#6B7280",
                textTransform: "uppercase",
                fontWeight: 600,
                display: "block",
                marginBottom: 6,
              }}
            >
              Connection details
            </span>
            <div
              style={{
                background: "#F9FAFB",
                padding: 10,
                borderRadius: 6,
                border: "1px solid #E5E7EB",
                fontSize: 12,
                fontFamily: "monospace",
                color: "#4B5563",
                lineHeight: 1.4,
              }}
            >
              <div>
                [Heartbeat] Last seen alive:{" "}
                {asset.lastSeen ||
                  (asset.last_seen_at
                    ? new Date(asset.last_seen_at).toLocaleString()
                    : "Never")}
              </div>
              <div>
                [SSH] Key authentication status:{" "}
                {(() => {
                  const testRes = connectionTestResult[asset.ip];
                  if (testRes) {
                    return testRes.success ? "Verified" : "Failed";
                  }
                  return "Not Configured";
                })()}
              </div>
            </div>
          </div>

          {asset.management_type === "agentless_snmp" ||
          asset.asset_category === "router" ? (
            <div style={{ borderTop: "1px solid #F3F4F6", paddingTop: 14 }}>
              <span
                className="badge badge-status-active"
                style={{ display: "inline-block" }}
              >
                Agentless Monitored
              </span>
            </div>
          ) : (
            <div
              style={{
                borderTop: "1px solid #F3F4F6",
                paddingTop: 14,
                display: "flex",
                gap: 8,
              }}
            >
              <button
                onClick={() => {
                  onClose();
                  if (onDeployAgent) {
                    onDeployAgent([asset.id], {
                      isRedeploy: asset.status === "onboarded",
                    });
                  }
                }}
                style={{
                  flex: 1,
                  padding: "8px 16px",
                  background:
                    asset.status === "onboarded" ? "#F3F4F6" : "#1D4ED8",
                  color: asset.status === "onboarded" ? "#1F2937" : "#fff",
                  border:
                    asset.status === "onboarded"
                      ? "1px solid #D1D5DB"
                      : "none",
                  borderRadius: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                }}
              >
                <Icon
                  name={asset.status === "onboarded" ? "refresh-cw" : "send"}
                  size={14}
                />
                {asset.status === "onboarded"
                  ? "Redeploy Agent"
                  : "Deploy Agent"}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AssetProfileDrawer;
